const DEFAULT_REDACT_FIELDS = [
  'authorization',
  'cookie',
  'set-cookie',
  'token',
  'access_token',
  'refresh_token',
  'id_token',
  'api_key',
  'api-key',
  'x-api-key',
  'password',
  'secret',
  'jwt',
] as const;

const parseLogLevel = (value: string | undefined): 'debug' | 'info' | 'warn' | 'error' => {
  if (value === 'debug' || value === 'warn' || value === 'error' || value === 'info') {
    return value;
  }
  return 'info';
};

const parseRedactFields = (value: string | undefined) => {
  const parsed = value
    ?.split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean);

  if (!parsed || parsed.length === 0) {
    return [...DEFAULT_REDACT_FIELDS];
  }

  return parsed;
};

export const loggingConfig = {
  level: parseLogLevel(import.meta.env.VITE_LOG_LEVEL),
  enableSentry: import.meta.env.VITE_LOG_TO_SENTRY !== 'false',
  redactFields: parseRedactFields(import.meta.env.VITE_LOG_REDACT_FIELDS),
  service: 'blms-web',
  env: import.meta.env.MODE || import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
};

export type LoggingConfig = typeof loggingConfig;
